/**
 * Non-mutating overlay for host-only handlers.
 * @param {object} config
 * @param {{ onClick?: Function, showIf?: Function }} [handlers]
 * @returns {object}
 */
export function withHandlers(config, handlers = {}) {
  if (!config || typeof config !== 'object') return config;
  const next = { ...config };
  if (Object.prototype.hasOwnProperty.call(handlers, 'onClick')) {
    next.onClick = handlers.onClick;
  }
  if (Object.prototype.hasOwnProperty.call(handlers, 'showIf')) {
    next.showIf = handlers.showIf;
  }
  return next;
}

/**
 * Walk an ElementConfig tree and collect key → onClick map.
 * @param {object|Array} configs
 * @param {Record<string, Function>} [map]
 * @returns {Record<string, Function>}
 */
export function collectCallbacks(configs, map = {}) {
  if (configs == null) return map;

  if (Array.isArray(configs)) {
    configs.forEach((c) => collectCallbacks(c, map));
    return map;
  }

  if (typeof configs !== 'object') return map;

  if (configs.key != null && typeof configs.onClick === 'function') {
    map[String(configs.key)] = configs.onClick;
  }

  const children = configs.children;
  if (Array.isArray(children)) {
    children.forEach((c) => collectCallbacks(c, map));
  } else if (children && typeof children === 'object' && children.tag) {
    collectCallbacks(children, map);
  }

  return map;
}
